// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".date[data-v-76e66506]{color:#656e81;font-size:14px}.title[data-v-76e66506]{color:#051638}.news-list[data-v-76e66506]{border-bottom:1px solid #f0f2f5}.news-list[data-v-76e66506]:last-child{border-bottom:none}.news-list:hover .date[data-v-76e66506],.news-list:hover .title[data-v-76e66506]{opacity:.6;transition:all .3s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
